/* eslint-disable max-len */
import React from 'react'
import calculatePercentage from '../../../../../CommonMethods/percentageCalculator'

export default function TableBody({tableItem, monthDorpDown, pageType}) {
    return (
        <>
            <tr>
                <td class="text-start">
                    {pageType === "staff" ? tableItem?.employee_number : tableItem?.student_id}
                </td>
                <td class="text-start"><span className='' title={pageType === "staff" ? tableItem?.full_name : tableItem?.student_name}>{pageType === "staff" ? tableItem?.full_name : tableItem?.student_name}</span></td>
                <td class="text-start">{pageType === "staff" ? tableItem?.staff_type : tableItem?.gender}</td>
                <td class="text-end border-l border-[#EDEDED]">
                    <span>
                        {tableItem?.total_yearly_total_days}
                    </span>
                </td>
                <td class="text-end">
                    <span>
                        {tableItem?.total_yearly_present_days}
                    </span>
                </td>
                <td class="text-end ">
                    <span>{calculatePercentage(tableItem.total_yearly_present_days, tableItem.total_yearly_total_days)}%</span>
                </td>
                <td class="text-end border-r border-[#EDEDED]">
                    <span>
                        {tableItem?.total_yearly_absent_days}
                    </span>
                </td>
                {monthDorpDown.map((monthItem, monthIndex) => {
                    const matchingMonthData = tableItem?.monthlyData?.find(item => {
                        const monthShort = new Date(2000, item.month - 1, 1).toLocaleString('en-US', { month: 'short' });
                        return monthShort === monthItem.slice(0, 3);
                    });

                    return (
                        <td key={monthIndex} className={`text-end ${monthIndex + 1 === monthDorpDown?.length ? "" : ""}`}>
                            <span>{matchingMonthData && Number(matchingMonthData?.total_days) > 0 ? `${calculatePercentage(matchingMonthData?.present_days, matchingMonthData?.total_days)}%` : "-"}</span>
                        </td>
                    );
                })}



                
            </tr>
            
        </>
    )
}
